export const invoicelistdata = [
    {
      id: "1",
      customer: "Abdallah T",
      customer_phone : "20214201",
      image:"user-27.jpg",
      reference_customer:"CMDC-250001",
      reference_shop:"CMDS-250171",
      shop : "LA MARSA",
      lab : "HOOKER",
      date:"24 Dec 2025",
      status:"Completed",
      total_ttc:"1000",
      paid_ttc:"1000",
      due:"0.00",
      paymentstatus:"Paid",
      biller:"Ahmed Ben Ahmed",
      action:"",
      delivery_date:"03 Oct 2025",
      last_payment_date: "24 Dec 2025",
      discount_ttc:"200",
      notice : "A préparer avant 11h00",
     sales_number:"VEN-250100",
     invoice_number:"FA-250001",
     quote_status:"Waiting for response",
    },
    {
      id: "2",
      customer: "Hotel Xxxx",
      image:"user-02.jpg",
      reference_customer:"",
      date:"10 Dec 2025",
      status:"Waiting",
      total_ttc:"1500",
      paid_ttc:"0.00",
      due:"1500",
      paymentstatus:"Unpaid",
      biller:"Talel Xxxxx",
      action:"",
      reference_shop:"CMDS-250113",
      lab : "HOOKER",
      shop : "LA MARSA",
      delivery_date:"20 Jan 2025",
      customer_phone : "55987654",
      last_payment_date:"",
      discount_ttc:"0.00",
      notice : "Pour mariage",
      sales_number:"",
      invoice_number:"FA-250002",
      quote_status:"Validated",
    },
  
    {
      id: "5",
      customer: "Mark Joslyn",
      image:"user-03.jpg",
      reference_customer:"CMDC-250005",
      date:"06 Nov 2025",
      status:"Delivered",
      total_ttc:"800",
      paid_ttc:"800",
      due:"0.00",
      paymentstatus:"Paid",
      biller:"Mohamed KABANI",
      action:"",
      reference_shop:"CMDS-250250",
      lab : "BRAZIL",
      shop : "TAIEB",
      delivery_date:"06 Nov 2025",
      customer_phone : "70560560",
      discount_ttc:"50.00",
      last_payment_date: "06 Nov 2025",
      sales_number:"VEN-250103",
      invoice_number:"FA-250003",
      quote_status:"In progress",
    },
    {
      id: "6",
      customer: "Hotel Xxxxx",
      image:"user-03.jpg",
      reference_customer:"CMDC-250006",
      date:"06 Nov 2025",
      status:"Canceled",
      total_ttc:"0",
      paid_ttc:"0",
      due:"0.00",
      paymentstatus:"Paid",
      biller:"Mohamed KABANI",
      action:"",
      reference_shop:"",
      lab : "BRAZIL",
      shop : "TAIEB",
      delivery_date:"06 Nov 2025",
      customer_phone : "71569871",
      discount_ttc:"000.00",
      sales_number:"",
      invoice_number:"FA-250004",
      quote_status:"In progress",
    }
  ];